/**
     * @desc 5上架我的系统盲盒
用于：个人盲盒列表页
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/uploadMySystemBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/uploadMySystemBox', params);
}
